import { Grid } from "@mui/material";
import { useSelector } from "react-redux";
import KinInfo from "./UserKin/KinInfo";
import { useLocation } from "react-router-dom";
import FetchHook from "../../../Api/FetchHooks";
import UserResidentialAddress from "./UserResidentialAddress";
import { Masonry } from "@mui/lab";
import { useCallback, useEffect, useState } from "react";

const UserProfileInfo = () => {
  const location = useLocation();
  const loggedInUser = useSelector((state) => state.auth.user);

  const [user, setUser] = useState(location.state?.user || loggedInUser);

  const [userLoading, userResponse, userRequest] = FetchHook();

  const fetchData = useCallback(async () => {
    userRequest({ url: `/entity?type=customer&entity_id=${user.id}` });
  }, [user]);

  useEffect(() => {
    if (userResponse?.data?.Data?.[0]) setUser(userResponse.data.Data[0]);
  }, [userResponse]);

  return (
    <>
      {/* <UserTabs user= {user} fetchUser={() => fetchData()} /> */}

      <Masonry columns={{ xs: 1, sm: 1, md: 2 }} spacing={2}>
        {/* <Grid>
          <UserInfoCard user={user} fetchUser={fetchData} />
        </Grid> */}

        <Grid>
          <UserResidentialAddress user={user} fetchUser={fetchData} />
        </Grid>
        <Grid>
          <KinInfo user={user} fetchUser={fetchData} />
        </Grid>
      </Masonry>
    </>
  );
};

export default UserProfileInfo;
